module.exports = __webpack_public_path__ + "img/img30.a3834ee0.png";